import React, { Component } from 'react';

// Styles
import 'aos/dist/aos.css';
import { Spinner } from 'react-bootstrap';
import GitCard from './GitCard';
import AOS from 'aos';

// Importing Axios
import Axios from "axios";

// Importing Api Keys
import { github_api_key } from '../../firebase/env';

// Colors
const colors = [ "blue", "red", "lightgreen", "yellow", "green", "darkblue", "orange", "pink", "brown", "violet" ];

const baseURL = (repo) =>
`https://api.github.com/repos/Code-Mergers/${repo}`;

// Github Pages Class
export default class GithubPage extends Component {
      
      state = {
        repo: [],
        load: false
      }
      
      async componentDidMount() {    
        AOS.init({ duration: 1000, delay: 0, once: true })
        let repo = [
          baseURL(`UI-Auth-Template-Using-React`),
          baseURL(`Healthify-React-App`),
          baseURL(`housify-cm`),
          baseURL('UI-Auth-Template-Using-MERN'),
          baseURL(`Web-To-Android-App-Template`),
          baseURL(`simple_site_maintenance`),
          baseURL(`SmartClass-Public`),
          baseURL(`Lab-Monitoring-System `)
        ];
    
        repo.map(
          async (url) =>
            await Axios.get(url, {
              headers: {
                Authorization: `token ${github_api_key}`,
              },
            }).then(async (res) => {
              this.setState({
                repo: [...this.state.repo, res.data],
                load: true
              });
            })
        );
    }

    render() {
        return (<>
                <div className="main-container">
                    {
                        this.state.load?
                        <>
                          <h3 data-aos="slide-right" data-aos-delay="200" id="main-h3">
                              Github Repositories
                          </h3>
                          <div className="github-cards" >
                            {
                              this.state.repo.map((oneRepo, index) =>
                                <GitCard key={index} 
                                  title={oneRepo.name} language={oneRepo.language}
                                  star={oneRepo.stargazers_count} 
                                  fork={oneRepo.forks_count}
                                  color={colors[index%colors.length]}
                                  description={oneRepo.description}
                                  repoLink={oneRepo.html_url}
                                  pageUrl={oneRepo.homepage}
                                />
                              )
                            }
                          </div>
                        </>
                        :<div style={{ 
                          height: "20vh",
                          marginTop: "100px",
                          display: "flex",
                          justifyContent: "center" }}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    }
                </div>
            </>
        )
    }
}
 